<script lang="ts">
	import RestStopHighlightForKleber from '$lib/components/pois/card/restStop/RestStopHighlightForKleber.svelte';

	interface Props {
		subtitle?: string;
		highlight?: { text: string; type: 'kleber' };
	}

	const { subtitle, highlight }: Props = $props();
</script>

{#if subtitle}
	<div>
		<span class="truncate text-sm text-coloredneutral-soft">{subtitle}</span>
	</div>
{/if}

{#if highlight?.type === 'kleber'}
	<RestStopHighlightForKleber {...highlight} />
{/if}
